export interface UpdateNotificationInputApiModel {
    readDate: Date;
}